import React from 'react';
import { Link } from 'react-router-dom';
export function TestimonialsSection() {
  return <section className="w-full py-24 px-4 sm:px-6 lg:px-8" style={{
    background: '#111111'
  }} data-id="element-453">
      <div className="max-w-5xl mx-auto" data-id="element-454">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-455">
          <p className="text-xs font-bold uppercase mb-3" style={{
          color: '#CC0000',
          letterSpacing: '0.2em'
        }} data-id="element-456">
            Customer Reviews
          </p>
          <h2 className="font-black text-white text-4xl sm:text-5xl" data-id="element-457">
            What Our Customers Say
          </h2>
        </div>

        {/* Testimonials grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-458">
          {/* Card 1 */}
          <div className="p-10 flex flex-col" style={{
          background: '#1a1a1a',
          borderLeft: '4px solid #CC0000'
        }} data-id="element-459">
            <div className="flex gap-1 mb-6" aria-label="5 out of 5 stars" data-id="element-460">
              <span className="text-xl" style={{
              color: '#FECB00'
            }} data-id="element-461">
                ★
              </span>
              <span className="text-xl" style={{
              color: '#FECB00'
            }} data-id="element-462">
                ★
              </span>
              <span className="text-xl" style={{
              color: '#FECB00'
            }} data-id="element-463">
                ★
              </span>
              <span className="text-xl" style={{
              color: '#FECB00'
            }} data-id="element-464">
                ★
              </span>
              <span className="text-xl" style={{
              color: '#FECB00'
            }} data-id="element-465">
                ★
              </span>
            </div>
            <blockquote className="text-lg leading-relaxed flex-1 mb-8 italic font-light" style={{
            color: 'rgba(255,255,255,0.90)'
          }} data-id="element-466">
              "Fast, friendly, and affordable! I got my tires replaced the same
              day. The team was professional and explained everything clearly.
              Highly recommend Ameritech!"
            </blockquote>
            <div className="flex items-center gap-4" data-id="element-467">
              <div className="w-12 h-12 rounded-full flex items-center justify-center text-white font-black text-sm flex-shrink-0" style={{
              background: '#CC0000'
            }} data-id="element-468">
                TR
              </div>
              <div data-id="element-469">
                <div className="font-black text-white text-sm" data-id="element-470">T. Robinson</div>
                <div className="text-xs mt-0.5" style={{
                color: '#616365'
              }} data-id="element-471">
                  Cottage City, MD
                </div>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="p-10 flex flex-col" style={{
          background: '#1a1a1a',
          borderLeft: '4px solid #1A3BCC'
        }} data-id="element-472">
            <div className="flex gap-1 mb-6" aria-label="5 out of 5 stars" data-id="element-473">
              <span className="text-xl" style={{
              color: '#FECB00'
            }} data-id="element-474">
                ★
              </span>
              <span className="text-xl" style={{
              color: '#FECB00'
            }} data-id="element-475">
                ★
              </span>
              <span className="text-xl" style={{
              color: '#FECB00'
            }} data-id="element-476">
                ★
              </span>
              <span className="text-xl" style={{
              color: '#FECB00'
            }} data-id="element-477">
                ★
              </span>
              <span className="text-xl" style={{
              color: '#FECB00'
            }} data-id="element-478">
                ★
              </span>
            </div>
            <blockquote className="text-lg leading-relaxed flex-1 mb-8 italic font-light" style={{
            color: 'rgba(255,255,255,0.90)'
          }} data-id="element-479">
              "They explained everything clearly and helped me choose the right
              tires for my car. Great service at a fair price. I won't go
              anywhere else for my tires!"
            </blockquote>
            <div className="flex items-center gap-4" data-id="element-480">
              <div className="w-12 h-12 rounded-full flex items-center justify-center text-white font-black text-sm flex-shrink-0" style={{
              background: '#1A3BCC'
            }} data-id="element-481">
                MC
              </div>
              <div data-id="element-482">
                <div className="font-black text-white text-sm" data-id="element-483">M. Carter</div>
                <div className="text-xs mt-0.5" style={{
                color: '#616365'
              }} data-id="element-484">
                  Suitland, MD
                </div>
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="p-10 flex flex-col" style={{
          background: '#1a1a1a',
          borderLeft: '4px solid #CC0000'
        }} data-id="element-485">
            <div className="flex gap-1 mb-6" aria-label="5 out of 5 stars" data-id="element-486">
              <span className="text-xl" style={{
              color: '#FECB00'
            }} data-id="element-487">
                ★
              </span>
              <span className="text-xl" style={{
              color: '#FECB00'
            }} data-id="element-488">
                ★
              </span>
              <span className="text-xl" style={{
              color: '#FECB00'
            }} data-id="element-489">
                ★
              </span>
              <span className="text-xl" style={{
              color: '#FECB00'
            }} data-id="element-490">
                ★
              </span>
              <span className="text-xl" style={{
              color: '#FECB00'
            }} data-id="element-491">
                ★
              </span>
            </div>
            <blockquote className="text-lg leading-relaxed flex-1 mb-8 italic font-light" style={{
            color: 'rgba(255,255,255,0.90)'
          }} data-id="element-492">
              "Had a blowout at 2am and called Ameritech. They were there in
              under 40 minutes. Incredible service, incredibly professional.
              Saved my night."
            </blockquote>
            <div className="flex items-center gap-4" data-id="element-493">
              <div className="w-12 h-12 rounded-full flex items-center justify-center text-white font-black text-sm flex-shrink-0" style={{
              background: '#CC0000'
            }} data-id="element-494">
                DJ
              </div>
              <div data-id="element-495">
                <div className="font-black text-white text-sm" data-id="element-496">D. Johnson</div>
                <div className="text-xs mt-0.5" style={{
                color: '#616365'
              }} data-id="element-497">
                  Capitol Heights, MD
                </div>
              </div>
            </div>
          </div>

          {/* Card 4 */}
          <div className="p-10 flex flex-col" style={{
          background: '#1a1a1a',
          borderLeft: '4px solid #1A3BCC'
        }} data-id="element-498">
            <div className="flex gap-1 mb-6" aria-label="5 out of 5 stars" data-id="element-499">
              <span className="text-xl" style={{
              color: '#FECB00'
            }} data-id="element-500">
                ★
              </span>
              <span className="text-xl" style={{
              color: '#FECB00'
            }} data-id="element-501">
                ★
              </span>
              <span className="text-xl" style={{
              color: '#FECB00'
            }} data-id="element-502">
                ★
              </span>
              <span className="text-xl" style={{
              color: '#FECB00'
            }} data-id="element-503">
                ★
              </span>
              <span className="text-xl" style={{
              color: '#FECB00'
            }} data-id="element-504">
                ★
              </span>
            </div>
            <blockquote className="text-lg leading-relaxed flex-1 mb-8 italic font-light" style={{
            color: 'rgba(255,255,255,0.90)'
          }} data-id="element-505">
              "Best tire shop in the DMV. Fair prices, honest advice, and they
              never try to upsell you on things you don't need. My whole family
              comes here."
            </blockquote>
            <div className="flex items-center gap-4" data-id="element-506">
              <div className="w-12 h-12 rounded-full flex items-center justify-center text-white font-black text-sm flex-shrink-0" style={{
              background: '#1A3BCC'
            }} data-id="element-507">
                KW
              </div>
              <div data-id="element-508">
                <div className="font-black text-white text-sm" data-id="element-509">K. Williams</div>
                <div className="text-xs mt-0.5" style={{
                color: '#616365'
              }} data-id="element-510">
                  Cottage City, MD
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-14 text-center" data-id="element-511">
          <Link to="/reviews" className="inline-block font-black uppercase tracking-widest px-12 py-4 text-sm transition-colors duration-200" style={{
          border: '2px solid #CC0000',
          color: '#CC0000'
        }} onMouseEnter={e => {
          e.currentTarget.style.background = '#CC0000';
          e.currentTarget.style.color = '#ffffff';
        }} onMouseLeave={e => {
          e.currentTarget.style.background = 'transparent';
          e.currentTarget.style.color = '#CC0000';
        }} data-id="element-512">
            Leave a Review
          </Link>
        </div>
      </div>
    </section>;
}